import { render, staticRenderFns } from "./forMoreLink.static.vue?vue&type=template&id=9395a8c6&scoped=true"
import script from "./forMoreLink.static.vue?vue&type=script&lang=js"
export * from "./forMoreLink.static.vue?vue&type=script&lang=js"
import style0 from "./forMoreLink.static.vue?vue&type=style&index=0&id=9395a8c6&prod&scoped=true&lang=scss"
import style1 from "./forMoreLink.static.vue?vue&type=style&index=1&id=9395a8c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9395a8c6",
  null
  
)

export default component.exports